module.exports = __webpack_public_path__ + "7b3d9ec0952f63c5cf05f543c3a1a043.png";